import { clientBase } from "../common";
export const getItems = (_id) => {
  return clientBase(`v2/mentory/courses/${_id}`, "get");
};
